/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { TabContext, TabPanel } from '@material-ui/lab';
import { useQuery } from 'react-apollo';
import { Link } from 'react-router-dom';
import {  Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import findCategoryPageByUrl from '../../../../../../../../gql/queries/findCategoryPageByURL';
import ProductItem from '../../../../../../GraphqlCommonComponents/TrendingProducts/Partials/ProductItem';
import PictureComponent from '../PictureComponent/PictureComponent';

const DesktopContentView = (props) => {
    const { activeTab: { image, link, value }, brand } = props;

    const currency = 'USD';
    const url = link?.href;
    const PRODUCT_QUERY = findCategoryPageByUrl(brand.domain, url, 'standard_collections', null, null, false, currency, null);
    const { loading, data } = useQuery(PRODUCT_QUERY);

    if (loading) return 'Loading...';

    const { products = [] } = data?.findCategoryPageByUrl?.category || {};
    products.splice(6);

    return (
        <Grid className="tab-content-holder" container>
            <TabContext>
                <Grid
                    md={5}
                    lg={5}
                    sm={6}
                >
                    <TabPanel>
                        <Link to={link?.href} className="tab-content-image" passHref aria-label={link?.title}>
                            <PictureComponent srcSet={image?.url} src={image?.url} alt={link?.title} width={490} height={516} />
                        </Link>
                    </TabPanel>
                </Grid>
                <Grid md={7} lg={7} sm={6} className="tab-container-grid">
                    <div>
                        <div style={{ display: 'block' }}>
                            <Grid className="row">
                                {products?.map((product, index) => {
                                    const itemData = {
                                        key: product.id,
                                        item: product,
                                        index,
                                        link,
                                    };
                                    return (
                                        <Grid md={4} lg={4} className="product-container" index={index} value={value}>
                                            <div>
                                                <div style={{ cursor: 'pointer', position: 'relative', width: '100%' }}>
                                                    <ProductItem item={itemData} isPlantsForOccasions brand={brand} />
                                                </div>
                                            </div>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </div>
                    </div>
                </Grid>
            </TabContext>
        </Grid>
    );
};

DesktopContentView.propTypes = {
    activeTab: PropTypes.object.isRequired,
    brand: PropTypes.object.isRequired,
};

export default DesktopContentView;
